// extracted by css-extract-rspack-plugin
export default {"card":"GiNKV6ot0D06amZL","heading":"R717qO4KUvs84CNQ","fieldGroup":"tmZbGRxy__Akx_qv","placeholder":"AcT2pHSP138Km4Vq","backLink":"EPJUa3kthtk_GdP5"};